import { render } from "./TaskItem.vue?vue&type=template&id=a2c19000&ts=true"
import script from "./TaskItem.vue?vue&type=script&lang=ts"
export * from "./TaskItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__